import React, { useContext, useEffect, useState } from 'react';

import { Grid, Hidden, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../../store';

import Input from '../../../../components/Input';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { onContinue } from '../TeeSheetCreator/Utils/onContinue';
import { Teams } from './Components/Teams';
import { TeamsCreatorProvider } from './Context/TeamsCreator.context';
import { TeamsCreatorPlayerSelector } from './Components/TeamsCreatorPlayerSelector/TeamsCreatorPlayerSelector';
import { TeamsCreatorStyled } from './TeamsCreator.Styles';
import { TeamPlayerSelectorModal } from './Components/TeamPlayerSelectorModal/TeamPlayerSelectorModal';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { TeeSheetCreatorProvider } from '../TeeSheetCreator/Context/TeeSheetCreator.context';

export const TeamsCreator = () => {
  const {
    actions: {
      adminEventTeams: { get: getAdminEventTeams }
    }
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const [searchValue, setSearchValue] = useState('');

  const search = (evnt: any) => setSearchValue(evnt.target.value);

  useEffect(() => {
    getAdminEventTeams(clubId, eventId);
  }, [clubId, eventId]);

  return (
    <TeeSheetCreatorProvider>
      <TeamsCreatorProvider>
        <div className={`event-wizard-page`}>
          <TeamsCreatorStyled>
            {clubId && eventId && roundId && (
              <EventWizardStepTitle
                buttonText="SAVE & CONTINUE"
                buttonOnClick={onContinue(clubId, eventId, roundId, 'teesheet')}
                title="TEAMS"
              />
            )}

            <Grid container={true} spacing={2}>
              <Grid item={true} xs={12} sm={6} md={8} />

              <Grid item={true} xs={12} sm={6} md={4}>
                <Input
                  id="player-lookup"
                  label="PLAYER LOOKUP"
                  onChange={search}
                  outlined={true}
                  placeholder="PLAYER LOOKUP"
                  type="search"
                  value={searchValue}
                />
              </Grid>
            </Grid>

            <div className="team-cards-container">
              <Grid container={true} spacing={2}>
                <Hidden smDown={true}>
                  <Grid item={true} xs={4}>
                    <Paper className="paper">
                      <TeamsCreatorPlayerSelector />
                    </Paper>
                  </Grid>
                </Hidden>

                <Grid item={true} xs={12} md={8}>
                  <Teams searchValue={searchValue} />
                </Grid>
              </Grid>
            </div>
          </TeamsCreatorStyled>
        </div>

        <TeamPlayerSelectorModal />
      </TeamsCreatorProvider>
    </TeeSheetCreatorProvider>
  );
};
